// Tabla de etapas de la reforma (progreso de scroll 0..1 → etapa 0..6). La comparten la escena y la página:
// así los paneles de texto responden al scroll desde el primer momento, aunque la escena 3D aún esté cargando.
export const STAGES = [0, 0.10, 0.24, 0.40, 0.55, 0.68, 0.86, 1.0001];
export const stageOf = p => { for (let i = 0; i < 7; i++) if (p < STAGES[i + 1]) return i; return 6; };
